<template>
  <svg
    class="BaseIcon"
    :class="{ 'is-active': active }"
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    :aria-labelledby="iconName"
    :viewBox="viewBox"
    role="presentation"
  >
    <g :fill="iconColor">
      <component
        :is="`icon-${iconName}`"
        :active="active"
        :activeStyle="activeStyle || false"
      />
    </g>
  </svg>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-facing-decorator'
import IconAngleRight from './icons/IconAngleRight.vue'
import IconAngleUp from './icons/IconAngleUp.vue'
import IconArrowUp from './icons/IconArrowUp.vue'
import IconArrowLeft from './icons/IconArrowLeft.vue'
import IconArrowForward from './icons/IconArrowForward.vue'
import IconClose from './icons/IconClose.vue'
import IconCloseCircle from './icons/IconCloseCircle.vue'
import IconCloseCircleFilled from './icons/IconCloseCircleFilled.vue'
import IconComment from './icons/IconComment.vue'
import IconEdit from './icons/IconEdit.vue'
import IconEditFilled from './icons/IconEditFilled.vue'
import IconExpand from './icons/IconExpand.vue'
import IconHome from './icons/IconHome.vue'
import IconImage from './icons/IconImage.vue'
import IconLightBulb from './icons/IconLightBulb.vue'
import IconLink from './icons/IconLink.vue'
import IconMore from './icons/IconMore.vue'
import IconPlus from './icons/IconPlus.vue'
import IconReference from './icons/IconReference.vue'
import IconShare from './icons/IconShare.vue'
import IconShrink from './icons/IconShrink.vue'
import IconSmile from './icons/IconSmile.vue'
import IconStarFilled from './icons/IconStarFilled.vue'
import IconHeart from './icons/IconHeart.vue'
import IconSearch from './icons/IconSearch.vue'
import IconQuestion from './icons/IconQuestion.vue'
import IconFire from './icons/IconFire.vue'
import IconLock from './icons/IconLock.vue'
import IconCheckCircle from './icons/IconCheckCircle.vue'
import IconCheckboxChecked from './icons/IconCheckboxChecked.vue'
import IconCheckboxUnchecked from './icons/IconCheckboxUnchecked.vue'
import IconReplay from './icons/IconReplay.vue'
import IconPlay from './icons/IconPlay.vue'
import IconClock from './icons/IconClock.vue'
import IconComment2 from './icons/IconComment2.vue'
import IconHeartFilled from './icons/IconHeartFilled.vue'
import IconHeartBorderFilled from './icons/IconHeartBorderFilled.vue'
import IconTriangleRight from './icons/IconTriangleRight.vue'
import IconTriangleDown from './icons/IconTriangleDown.vue'
import IconMemo from './icons/IconMemo.vue'
import IconDelete from './icons/IconDelete.vue'
import IconKeep from './icons/IconKeep.vue'
import IconCamera from './icons/IconCamera.vue'

type IconName =
  | 'angle-right'
  | 'arrow-left'
  | 'angle-up'
  | 'arrow-up'
  | 'arrow-forward'
  | 'close'
  | 'close-circle'
  | 'close-circle-filled'
  | 'comment'
  | 'edit'
  | 'edit-filled'
  | 'expand'
  | 'home'
  | 'image'
  | 'light-bulb'
  | 'link'
  | 'more'
  | 'plus'
  | 'reference'
  | 'share'
  | 'shrink'
  | 'smile'
  | 'star-filled'
  | 'heart'
  | 'heart-filled'
  | 'heart-border-filled'
  | 'search'
  | 'question'
  | 'fire'
  | 'lock'
  | 'check-circle'
  | 'checkbox-checked'
  | 'checkbox-unchecked'
  | 'replay'
  | 'play'
  | 'clock'
  | 'comment-2'
  | 'triangle-right'
  | 'triangle-down'
  | 'memo'
  | 'keep'
  | 'delete'
  | 'camera'

@Component({
  components: {
    IconArrowLeft,
    IconAngleRight,
    IconAngleUp,
    IconArrowUp,
    IconArrowForward,
    IconClose,
    IconCloseCircle,
    IconCloseCircleFilled,
    IconComment,
    IconEdit,
    IconEditFilled,
    IconExpand,
    IconHome,
    IconImage,
    IconLightBulb,
    IconLink,
    IconMore,
    IconPlus,
    IconReference,
    IconShare,
    IconShrink,
    IconSmile,
    IconStarFilled,
    IconHeart,
    IconHeartFilled,
    IconHeartBorderFilled,
    IconSearch,
    IconQuestion,
    IconFire,
    IconLock,
    IconCheckCircle,
    IconCheckboxChecked,
    IconCheckboxUnchecked,
    IconReplay,
    IconPlay,
    IconClock,
    IconComment2,
    IconTriangleRight,
    IconTriangleDown,
    IconMemo,
    IconDelete,
    IconKeep,
    IconCamera
  }
})
export default class BaseIcon extends Vue {
  @Prop({ default: '' }) iconName: IconName
  @Prop({ default: 16 }) size: number
  @Prop({ default: 'currentColor' }) iconColor: string
  @Prop({ default: false }) active: boolean
  @Prop() activeStyle?: string
  @Prop({ default: '0 0 64 64' }) viewBox: string
}
</script>
